export const stories = [
    {
      id: '1',
      image: require(`@/assets/img/divacs-cover.svg`),
      tags: 'B2B SAAS',

      title: 'Scaling DIVACS With DIGU',
      description:
        'DIVACS scaled efficiently with DIGU, reducing costs by 75% and saving the founder 60% more time to focus on growth.',
      logo: require(`@/assets/img/divac-logo.svg`),
      route: '/divacs',
    },
    {
      id: '2',
      image: require(`@/assets/img/anthropic-cover.svg`),
      tags: 'B2B Services',
      title: 'Anthropic Identity Builds a Global IAM Force',
      description:
        'Anthropic Identity cut hiring time by 75% and built a global IAM team in just 2 weeks',
      logo: require(`@/assets/img/anthropic-logo.svg`),
      route: '/anthropic-identity',
    },
    {
      id: '3',
      image: require(`@/assets/img/sharpscribe.svg`),
      tags: 'B2B SAAS',
      title: 'SharpScribe Brings AI to the Doctor’s Office',
      description: 'SharpScribe built its AI MVP 40% faster',
      logo: require(`@/assets/img/sharpscribe-logo.svg`),
      route: '/sharp-scribe',
    },
]